export default __webpack_public_path__ + "static/logo_transparent-7505f3a479b859a7ac9ff611b873a68a.png";